import { render, staticRenderFns } from "./UiAccountPicker.vue?vue&type=template&id=80453b2c&scoped=true"
import script from "./UiAccountPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiAccountPicker.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80453b2c",
  null
  
)

export default component.exports